import { AddNumberProps } from './AddNewNumberOverlay';
import { Control, Controller, FieldErrorsImpl, RegisterOptions } from 'react-hook-form';
import SingleAutocompleteDropdown from '@cp/src/components/AutocompleteDropdown/SingleAutocompleteDropdown';

type ISingleAutoDropdownProps = {
  placeholder: string;
  errors: Partial<FieldErrorsImpl<AddNumberProps>>;
  containerClassName?: string;
  control: Control<AddNumberProps, any>;
  name: keyof AddNumberProps;
  rules: RegisterOptions;
  optionsList: {
    label: string;
    value: string;
  }[];
  selectedSource: string;
  handleSelectionChange: (selectedOption: any) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};
const SingleAutoDropdown = (props: ISingleAutoDropdownProps) => {
  const {
    placeholder,
    errors,
    control,
    name,
    rules,
    selectedSource,
    handleSelectionChange,
    optionsList
  } = props;

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value, ref } }) => (
          <SingleAutocompleteDropdown
            ref={ref}
            options={optionsList}
            disabled={false}
            notFoundCopy={
              optionsList.length > 0
                ? 'No results found! Try adding other source.'
                : 'No sources found'
            }
            customOptionsContainer="!max-h-[200px]"
            onSelectionChange={onChange}
            selectedOption={value?.value}
            placeholder={placeholder}
          />
        )}
      />
    </>
  );
};

export default SingleAutoDropdown;
